import { State } from '../@types';

export const selectPricing = (store: State) => store.pricing;
